<template>
  <div class="guide-wrapper">
    <div class="payment-noti-wrap">
      <div class="ticket-noti-wrap">
        <p class="dot-text"><span>wavve 서비스는 국내 및 해외 일부 해외 서비스 대상 국가에서 이용하실 수 있습니다.</span></p>
        <p class="dot-text"><span>국내에서 결제완료된 콘텐츠에 한해 해외 서비스 대상국가 여행 시 모바일 앱(ios/Android)으로 7일간 스트리밍(재생) 서비스를 이용하실 수 있습니다.</span></p>
        <p class="dot-text"><span>해외 서비스 대상국가 : 싱가폴, 인도네시아, 말레이시아, 필리핀, 베트남, 라오스, 태국</span></p>
        <p class="dot-text"><span>해외 서비스 대상국가가 아닌 지역에서는 서비스 이용이 불가하며, 일부 콘텐츠는 콘텐츠제공사(CP)의 별도 요청, 저작권 문제, 기타 사업권역 문제 등으로 해외 서비스 이용이 제한될 수 있습니다.</span></p>
        <p class="dot-text"><span>동시접속 상품은 한 계정당 구매하신 회선만큼 동시에 여러 기기에서 시청하실 수 있는 상품입니다. 1회선 이용 시에는 동시접속이 차단됩니다. </span></p>
        <p class="dot-text"><span>일부 콘텐츠는 저작권자의 요청에 따라 LIVE 및 VOD 서비스가 제공되지 않을 수 있습니다.</span></p>
        <p class="dot-text"><span>자동결제 시 이용기간 중 결제 당일을 제외하고 언제든지 자동결제를 해지하실 수 있습니다. </span></p>
        <p class="dot-text"><span>다운로드 무제한 이용권은 모바일 기기에서만 무제한 다운 가능하며, PC에서는 최대 30회까지 다운로드 가능합니다. </span></p>
        <p class="dot-text"><span>FHD 이용권 구매 시 시범 서비스 기간동안 TV기기 및 OTT 기기에서 일부 콘텐츠를 UHD로 이용하실 수 있습니다.</span></p>
        <p class="dot-text"><span>기타 자세한 사항은 이용권 안내 페이지를 참고해 주세요. </span></p>
        <p class="dot-text"><span>미사용 상품은 구매 후 7일 내 청약철회 가능하며, 법정대리인의 동의를 받지 않은 미성년자 거래는 취소 가능합니다.</span></p>
      </div>

      <input type="checkbox" id="payment-noti-more" class="noti-more-btn"><label for="payment-noti-more"></label>

      <div class="ticket-noti-more">
        <p class="dot-text"><span>회원이 유료 결제 후 사용하지 않은 상품은 구매일 기준 7일 내 청약 철회가 가능합니다.</span></p>
        <p class="dot-text"><span>고객센터>1:1문의하기 메뉴를 통해 청약철회 의사를 표시할 수 있으며, 접수일로부터 3영업일 이내 결제 취소 또는 현금 환불해 드립니다. 다만, 각 호의 경우에는 결제취소처리가 불가능합니다.<br/>
              &nbsp;&nbsp;①이벤트, 쿠폰, 보상 등 결제수단이 무료로 지급된 경우<br/>
              &nbsp;&nbsp;②해당 기간 내에 사용내역이 있을 경우<br/>
              &nbsp;&nbsp;③해당 결제수단에 따른 결제취소 가능기간을 경과한 경우<br/></span></p>
        <p class="dot-text"><span>만 20세 미만의 미성년자의 유료서비스 이용은 법정대리인이 이를 취소할 수 있습니다. (단, 결제 수단의 명의자가 성년인 경우에는 취소 제한)</span></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>
  .guide-wrapper{
    margin-bottom: 120px;
  }
</style>
